import {
  __commonJS,
  __toESM
} from "./chunk-3IID4MV4.mjs";

// ../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js
var require_cjs = __commonJS({
  "../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";
    var isMergeableObject = function isMergeableObject2(value) {
      return isNonNullObject(value) && !isSpecial(value);
    };
    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== false && options.isMergeableObject(value) ? deepmerge2(emptyTarget(value), value, options) : value;
    }
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    function getMergeFunction(key, options) {
      if (!options.customMerge) {
        return deepmerge2;
      }
      var customMerge = options.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge2;
    }
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
      }) : [];
    }
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return false;
      }
    }
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    function mergeObject(target, source, options) {
      var destination = {};
      if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
      }
      getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
      });
      return destination;
    }
    function deepmerge2(target, source, options) {
      options = options || {};
      options.arrayMerge = options.arrayMerge || defaultArrayMerge;
      options.isMergeableObject = options.isMergeableObject || isMergeableObject;
      options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
      } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
      } else {
        return mergeObject(target, source, options);
      }
    }
    deepmerge2.all = function deepmergeAll(array, options) {
      if (!Array.isArray(array)) {
        throw new Error("first argument should be an array");
      }
      return array.reduce(function(prev, next) {
        return deepmerge2(prev, next, options);
      }, {});
    };
    var deepmerge_1 = deepmerge2;
    module.exports = deepmerge_1;
  }
});

// ../tokens/dist/chunk-7AF44TJR.mjs
var primitiveColor = {
  neutral: {
    0: "#FFFFFF",
    5: "#F6F9FA",
    10: "#F2F6F8",
    20: "#E4EBF0",
    30: "#D7E0E6",
    40: "#C7D2D8",
    50: "#9DA7AE",
    60: "#81898F",
    70: "#5F666B",
    80: "#3A3E41",
    90: "#25282A",
    95: "#1D2021",
    100: "#141617"
  },
  deepRed: {
    5: "#FFF8F7",
    10: "#FCEEED",
    20: "#FCD8D7",
    30: "#FDA5A2",
    40: "#FC7E79",
    50: "#F75A54",
    60: "#EB3E38",
    70: "#DE1912",
    80: "#B21712",
    90: "#8A120E",
    100: "#700F0B"
  },
  red: {
    5: "#FFF8F7",
    10: "#FFEFED",
    20: "#FFDFDB",
    30: "#FFC8C2",
    40: "#FFA399",
    50: "#FF7A6B",
    60: "#FF5542",
    70: "#F73620",
    80: "#E31700",
    90: "#C71704",
    100: "#941103"
  },
  orange: {
    5: "#FFF9F5",
    10: "#FFF0E5",
    20: "#FFE3CF",
    30: "#FFD0AD",
    40: "#FFBE8F",
    50: "#FF9C57",
    60: "#FF8026",
    70: "#FA6700",
    80: "#DE4A00",
    90: "#C24700",
    100: "#8F3400"
  },
  yellow: {
    5: "#FFF9F0",
    10: "#FFF6E5",
    20: "#FFEAC7",
    30: "#FFDEA6",
    40: "#FFCE7A",
    50: "#FFBE4D",
    60: "#FFAB24",
    70: "#FF9900",
    80: "#E58200",
    90: "#BA6900",
    100: "#874D00"
  },
  green: {
    5: "#F5FFF5",
    10: "#EBFFEB",
    20: "#CFFCCF",
    30: "#ACF2AC",
    40: "#96EB96",
    50: "#79E079",
    60: "#55D455",
    70: "#27C227",
    80: "#099E09",
    90: "#008000",
    100: "#185218"
  },
  mint: {
    5: "#F5FFFE",
    10: "#E5FFFD",
    20: "#BEFAF4",
    30: "#A0F2EA",
    40: "#82E8DE",
    50: "#5BE3D1",
    60: "#1ED4C1",
    70: "#00C7B3",
    80: "#00AD9D",
    90: "#009183",
    100: "#005E55"
  },
  blue: {
    5: "#F7FBFF",
    10: "#EDF6FF",
    20: "#D4EAFF",
    30: "#B2DAFF",
    40: "#8FC9FF",
    50: "#5CB1FF",
    60: "#2998FF",
    70: "#0085FF",
    80: "#006ACC",
    90: "#004F99",
    100: "#003566"
  },
  deepBlue: {
    5: "#F7F9FF",
    10: "#EDF1FC",
    20: "#D3DDFC",
    30: "#A7BBFC",
    40: "#7998FC",
    50: "#597EF7",
    60: "#3B66F5",
    70: "#2654EB",
    80: "#173BB2",
    90: "#122E8A",
    100: "#0F2775"
  },
  purple: {
    5: "#F9F7FF",
    10: "#F3F0FF",
    20: "#E1DBFF",
    30: "#CCC2FF",
    40: "#B2A3FF",
    50: "#9985FF",
    60: "#846BFF",
    70: "#6E50FF",
    80: "#4E35CC",
    90: "#402E99",
    100: "#2A1F66"
  },
  pink: {
    5: "#FFF7F8",
    10: "#FFEDF0",
    20: "#FFD6DC",
    30: "#FFBAC4",
    40: "#FF94A4",
    50: "#FF7086",
    60: "#FA5069",
    70: "#E8344E",
    80: "#D1213B",
    90: "#BD172F",
    100: "#8A1122"
  },
  neutralAlpha: {
    12: "#FFFFFF1F",
    20: "#FFFFFF33",
    60: "#14161799"
  },
  blueAlpha: {
    12: "#0035661F",
    15: "#00356626"
  }
};

// ../tokens/dist/chunk-YU3RS4QI.mjs
var baseSemanticColor = {
  brand: {
    strong: primitiveColor.pink[80],
    default: primitiveColor.pink[70],
    subtle: primitiveColor.pink[50],
    subtler: primitiveColor.pink[20],
    subtlest: primitiveColor.pink[5]
  },
  status: {
    success: {
      default: primitiveColor.green[70],
      subtle: primitiveColor.green[50],
      subtler: primitiveColor.green[20],
      subtlest: primitiveColor.green[10]
    },
    warning: {
      default: primitiveColor.yellow[70],
      subtle: primitiveColor.yellow[50],
      subtler: primitiveColor.yellow[20],
      subtlest: primitiveColor.yellow[10]
    },
    error: {
      default: primitiveColor.red[70],
      subtle: primitiveColor.red[50],
      subtler: primitiveColor.red[20],
      subtlest: primitiveColor.red[10]
    },
    processing: {
      default: primitiveColor.blue[70],
      subtle: primitiveColor.blue[50],
      subtler: primitiveColor.blue[20],
      subtlest: primitiveColor.blue[10]
    }
  },
  text: {
    primary: primitiveColor.neutral[100],
    secondary: primitiveColor.neutral[80],
    tertiary: primitiveColor.neutral[60],
    quaternary: primitiveColor.neutral[50],
    inverse: primitiveColor.neutral[0]
  },
  icon: {
    primary: primitiveColor.neutral[100],
    secondary: primitiveColor.neutral[80],
    tertiary: primitiveColor.neutral[60],
    quaternary: primitiveColor.neutral[50],
    inverse: primitiveColor.neutral[0]
  },
  background: {
    default: primitiveColor.neutral[0],
    subtle: primitiveColor.neutral[5]
  },
  line: {
    clickable: primitiveColor.blueAlpha[15],
    nonClickable: primitiveColor.blueAlpha[12]
  },
  dimm: {
    default: primitiveColor.neutralAlpha[60]
  }
};

// ../tokens/dist/chunk-UA42UUKW.mjs
var createVariableMap = (scheme, prefix) => {
  const vars2 = {};
  const processCategory = (category, value, path = [], target = vars2) => {
    if (typeof value === "string") {
      const varName = [prefix, category, ...path].join("-");
      const lastKey = path[path.length - 1];
      target[lastKey] = `var(--${varName})`;
    } else {
      const currentPath = path[path.length - 1];
      if (currentPath) {
        target[currentPath] = target[currentPath] || {};
      }
      Object.entries(value).forEach(([key, subValue]) => {
        processCategory(
          category,
          subValue,
          [...path, key],
          currentPath ? target[currentPath] : target
        );
      });
    }
  };
  Object.entries(scheme).forEach(([category, value]) => {
    vars2[category] = {};
    processCategory(category, value, [], vars2[category]);
  });
  return vars2;
};

// ../tokens/dist/chunk-F4KQDRNV.mjs
var primitiveColorVars = createVariableMap(
  primitiveColor,
  "stack-primitive"
);

// ../tokens/dist/chunk-6KJHDEST.mjs
var semanticColorVars = createVariableMap(
  baseSemanticColor,
  "stack-semantic"
);

// ../tokens/dist/chunk-RN74DUWM.mjs
var effect = {
  blur: {
    primary: "12%"
  },
  shadow: {
    elevation1: "0px 8px 24px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.12)",
    elevation2: "0px 18px 33px 0px rgba(0, 0, 0, 0.02), 0px 8px 40px 0px rgba(0, 0, 0, 0.10), 0px 0px 6px 0px rgba(0, 0, 0, 0.10)"
  }
};

// ../tokens/dist/chunk-HBPD6Q3T.mjs
var effectVars = createVariableMap(effect, "stack-semantic");

// ../tokens/dist/chunk-LK3IYL3P.mjs
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// ../tokens/dist/chunk-WUUZD6PV.mjs
var createEffectTheme = (partialEffects) => {
  return __spreadValues(__spreadValues({}, effect), partialEffects);
};

// ../tokens/dist/chunk-SL34Q7SQ.mjs
var createColorTheme = (partialColors) => {
  return __spreadValues(__spreadValues({}, baseSemanticColor), partialColors);
};

// ../tokens/dist/chunk-4KNYLG5C.mjs
var baseComponent = (theme) => {
  return {
    button: {
      solidPrimary: {
        background: theme.brand.default,
        backgroundHover: theme.brand.strong,
        text: primitiveColor.neutral[0],
        icon: primitiveColor.neutral[0]
      },
      solidSecondary: {
        background: primitiveColor.neutral[100],
        backgroundHover: primitiveColor.neutral[80],
        text: theme.text.inverse,
        icon: theme.icon.inverse
      },
      solidTertiary: {
        background: primitiveColor.neutral[20],
        backgroundHover: primitiveColor.neutral[30],
        text: theme.text.secondary,
        icon: theme.icon.secondary
      },
      solidError: {
        background: primitiveColor.red[70],
        backgroundHover: primitiveColor.red[80],
        text: primitiveColor.neutral[0],
        icon: primitiveColor.neutral[0]
      },
      outlinePrimary: {
        border: theme.brand.default,
        backgroundHover: theme.brand.subtlest,
        text: theme.brand.default,
        icon: theme.brand.default
      },
      outlineSecondary: {
        border: primitiveColor.neutral[30],
        backgroundHover: primitiveColor.neutral[10],
        text: theme.text.secondary,
        icon: theme.icon.secondary
      }
    }
  };
};

// ../tokens/dist/chunk-6PYW7GGU.mjs
var import_deepmerge = __toESM(require_cjs(), 1);
var createComponentTheme = (theme, partialTheme) => {
  return (0, import_deepmerge.default)(baseComponent(theme), partialTheme != null ? partialTheme : {});
};

// ../tokens/dist/chunk-BUKP2E4O.mjs
var createMetaTheme = (config) => {
  var _a, _b, _c;
  const baseTheme = __spreadValues(__spreadValues({}, createColorTheme((_a = config.colors) != null ? _a : {})), createEffectTheme(config.effects));
  return __spreadValues(__spreadValues({}, baseTheme), createComponentTheme(baseTheme, (_c = (_b = config.components) == null ? void 0 : _b.call(config, baseTheme)) != null ? _c : {}));
};

// ../tokens/dist/chunk-JHX73YIW.mjs
var componentColorVars = createVariableMap(
  baseComponent(__spreadValues(__spreadValues({}, createColorTheme(sccLight)), createEffectTheme(sccLight))),
  "stack-semantic"
);
var vars = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, primitiveColorVars), semanticColorVars), componentColorVars), effectVars);
var DEPRECATED_NEUTRAL_DAY = {
  gray90: "#1A1A1A",
  gray100: "#101010",
  white: "#FFFFFF"
};
var sccLight = createMetaTheme({
  colors: {
    brand: {
      strong: primitiveColor.pink[80],
      default: primitiveColor.pink[70],
      subtle: primitiveColor.pink[50],
      subtler: primitiveColor.pink[20],
      subtlest: primitiveColor.pink[5]
    }
  },
  effects: {},
  components: () => ({})
});

export {
  primitiveColor,
  baseSemanticColor,
  DEPRECATED_NEUTRAL_DAY
};
